import React from "react";

/*eslint-disable */

declare const window: any;
const TitleComponent: React.FC = () => {
  return (
    <div className="title-politicas-component">Política de Cookies</div>
  );
};

export default TitleComponent;
